import clsx from "clsx";
import React from "react";
import "./settingsContainerContent.scss";

interface ISettingsContainerContentProps extends React.ComponentPropsWithoutRef<"div"> { }

export const SettingsContainerContent = (props: ISettingsContainerContentProps) => {
    return <div {...props} className={clsx("settings-container-content", props.className)} />;
};
